import { DeviceSize } from '../../_declarations/device';
import breakpoints from './breakpoints';

const size: DeviceSize = {
  desktopL: `${breakpoints.desktopL}px`,
  desktopM: `${breakpoints.desktopM}px`,
  desktopS: `${breakpoints.desktopS}px`,
  desktopXl: `${breakpoints.desktopXl}px`,
  mobileM: `${breakpoints.mobileM}px`,
  mobileS: `${breakpoints.mobileS}px`,
  tablet: `${breakpoints.tablet}px`
};

export default {
  desktopL: `(max-width: ${breakpoints.desktopXl - 1}px)`,
  desktopM: `(max-width: ${breakpoints.desktopL - 1}px)`,
  desktopS: `(max-width: ${breakpoints.desktopM - 1}px)`,
  desktopXl: `(min-width: ${size.desktopXl})`,
  mobileM: `(max-width: ${breakpoints.tablet - 1}px)`,
  mobileS: `(max-width: ${breakpoints.mobileM - 1}px)`,
  tablet: `(max-width: ${breakpoints.desktopS - 1}px)`
} as DeviceSize;
